export default "__VITE_ASSET__Bm54nk6T__"